<template>
  <div class="app-install-wrap">
    <img src="@/assets/img/img_menu_bi.png" alt="appInstallationInduce">
    <p>
      7일 이전 거래 내역을 보시려면<br>
      앱을 <span>다운로드</span> 받아주세요
    </p>
    <button @click="callApp()">앱 다운받고 배달비 무제한 무료 혜택받기</button>
    <div class="app-install-info">
      <img src="@/assets/img/ic_20_info.png" alt="">
      회원가입 시 배달비 무제한 무료가 적용됩니다
    </div>
  </div>
</template>

<script>
import AppLinkMixins from '@/utils/AppLinkMixins.js'
export default {
  mixins: [AppLinkMixins],
}
</script>

<style scoped>
</style>
